var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { formatDate } from "../helpers/date";
import AbstractTypes from "./abstract";
var i18n = {
    DAYS_AGO: ac_search.i18n.days_ago,
    DAYS: ac_search.i18n.days,
};
var Date = /** @class */ (function (_super) {
    __extends(Date, _super);
    function Date() {
        var _this = _super.call(this) || this;
        _this.filter_type = 'date';
        return _this;
    }
    Date.prototype.renderDatePickerInputs = function (rule) {
        var $el1 = rule.$el.find('.rule-value-container input:first');
        var $el2 = rule.$el.find('.rule-value-container input:eq(1)');
        $el1.css({ position: 'relative', 'z-index': 1000 }).on('keydown', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 9) {
                e.preventDefault();
            }
        }).attr('autocomplete', 'off').datepicker({
            dateFormat: 'yy-mm-dd',
            changeYear: true,
            yearRange: "c-60:c+10",
            beforeShow: function () {
                jQuery('body').addClass('ac-jqui');
                jQuery('#ui-datepicker-div .ui-datepicker-year').hide();
            },
            onClose: function (selectedDate) {
                $el2.datepicker("option", "minDate", selectedDate).focus();
            }
        });
        $el2.css({ position: 'relative', 'z-index': 1000 }).attr('autocomplete', 'off').datepicker({
            dateFormat: 'yy-mm-dd',
            changeYear: true,
            yearRange: "c-60:c+10",
            beforeShow: function () {
                jQuery('body').addClass('ac-jqui');
            },
            onClose: function (selectedDate) {
                $el1.datepicker("option", "maxDate", selectedDate);
            }
        });
        this.setAfterLabel(rule, '');
    };
    Date.prototype.getAfterLabel = function (rule) {
        return rule.$el.find('.rule-value-container .rule-value-after-label').html();
    };
    Date.prototype.setAfterLabel = function (rule, label) {
        if (!rule.$el) {
            return;
        }
        if (rule.$el.find('.rule-value-container .rule-value-after-label').length === 0) {
            rule.$el.find('.rule-value-container').append("<span class=\"rule-value-after-label\"></span>");
        }
        rule.$el.find('.rule-value-container .rule-value-after-label').html(label);
    };
    Date.prototype.renderNumericInputs = function (rule) {
        var $el = rule.$el;
        $el.find('.rule-value-container input').attr('type', 'number').datepicker('destroy');
    };
    /**
     * @param {Rule} rule
     */
    Date.prototype.renderInput = function (rule) {
        var _this = this;
        if (this.filter_type !== rule.getFilter().filter_type) {
            return;
        }
        var $el2 = rule.$el.find('.rule-value-container input:eq(1)');
        if ($el2.is(':visible')) {
            rule.$el.find('.rule-value-container').addClass('between').find('.ac-s__separator').text('-');
        }
        var operatorSelect = rule.$el.find('.rule-operator-container select');
        operatorSelect.on('change', function () {
            _this.determineRenderInputs(rule);
        });
        this.determineRenderInputs(rule);
        rule.$el.addClass("rule-container--date");
    };
    Date.prototype.determineAfterLabel = function (rule) {
        switch (rule.getOperator()) {
            case 'lt_days_ago':
            case 'gt_days_ago':
                this.setAfterLabel(rule, i18n.DAYS_AGO);
                break;
            case 'within_days':
                this.setAfterLabel(rule, i18n.DAYS);
                break;
            default:
                this.setAfterLabel(rule, '');
        }
    };
    Date.prototype.determineRenderInputs = function (rule) {
        switch (rule.getOperator()) {
            case 'lt_days_ago':
            case 'gt_days_ago':
            case 'within_days':
                this.renderNumericInputs(rule);
                break;
            default:
                this.renderDatePickerInputs(rule);
        }
        this.determineAfterLabel(rule);
    };
    Date.prototype.transformFilter = function (filter) {
        if (filter.type === 'date' || filter.type === 'datetime') {
            filter.filter_type = this.filter_type;
        }
        return filter;
    };
    Date.prototype.ruleDisplayValue = function (value, rule) {
        if (!value) {
            return value;
        }
        switch (rule.getOperator()) {
            case 'lt_days_ago':
            case 'gt_days_ago':
            case 'within_days':
                return value + ' ' + this.getAfterLabel(rule);
            default:
                return formatDate('d M yy', value);
        }
    };
    return Date;
}(AbstractTypes));
export default Date;
